// extracted by mini-css-extract-plugin
export default {"title":"AddUtenteNew_title__mrtCC","container":"AddUtenteNew_container__q2lOR"};